/**
 * @param {Yup.objectSchema<Object>} schema - yup shape
 * @param {Object} data
 * @returns {{ status: boolean, data?: Object, errors?: Object}}
 */
import { ERRORS } from '@/shared/Auth/utils/Validator/errors'
import { Schema } from 'yup'

export function validateAll(schema: Schema, data: any) {
  const result = {
    status: true,
    data: data,
    errors: {},
  }

  try {
    schema.validateSync(data, { abortEarly: false })
  } catch (errors: any) {
    result.status = false
    result.errors = errors.inner.reduce((acc: any, e: any) => {
      const key = e.path.length === 0 ? 'unknown' : e.path
      if (!acc[key]) {
        acc[key] = e.message
      }
      return acc
    }, {} as any)
  }

  return result
}

export function validateAt(schema: Schema, path: string, value: any) {
  const result = {
    status: true,
    error: undefined,
  }
  try {
    schema.validateSyncAt(path, { [path]: value })
  } catch (error: any) {
    result.status = false
    result.error = error.message
  }

  return result
}

export function prepareApiErrors(error: { [key: string]: string | string[] }) {
  return Object.entries(error).reduce((acc: any, [key, value]) => {
    acc[key] = Array.isArray(value)
      ? // @ts-ignore
        (ERRORS[value[0]] ?? value[0])
      : // @ts-ignore
        (ERRORS[value] ?? value)
    return acc
  }, {})
}
